import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrepaidCheckoutSummaryViewModel } from '../../../../models/prepaid-wash-book.models';

@Component({
  selector: 'app-prepaid-checkout-summary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './prepaid-checkout-summary.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./prepaid-checkout-summary.component.scss'],
})
export class PrepaidCheckoutSummaryComponent {
  @Input({ required: true }) summary!: PrepaidCheckoutSummaryViewModel;
}
